import { TextEllipsis } from '@aibees/shared/components';
import {
  exportStatusColorMap,
  StatusTag,
} from '@aibees/shared/components/status-tag';
import { AdvanceTableConfig } from '@aibees/shared/features';
import {
  capitalize,
  DATE_FORMAT_DD_MMM_YYYY,
  fDateShort,
} from '@aibees/shared/utils';
import { CardBodyDate } from '../../styles';
import { EnrichTableAction } from './actions/enrich-table-action';
import { EnrichTableDownloadAction } from './actions/enrich-table-download-action';
import * as SX from './sx';
import { Enrichment } from './types';

export const config: Omit<AdvanceTableConfig<Enrichment>, 'browseApi'> = {
  columns: [
    {
      id: 'name',
      label: 'File Name',
      sortable: true,
      width: 120,
      render: (_, v) => (
        <TextEllipsis
          value={v.name}
          variant="body4"
          fontWeight={500}
          color="grey.800"
        />
      ),
    },
    {
      id: 'statistics',
      label: 'Rows',
      sortable: true,
      width: 30,
      render: (_, v) => (
        <TextEllipsis
          value={String(v.statistics.total)}
          w="98px"
          variant="body4"
          color="grey.700"
        />
      ),
    },
    {
      id: 'statistics',
      label: 'Matched',
      sortable: true,
      width: 30,
      render: (_, v) => (
        <TextEllipsis
          value={String(v.statistics.processed)}
          w="98px"
          variant="body4"
          color="grey.700"
        />
      ),
    },
    {
      id: 'modified',
      label: 'Created',
      sortable: true,
      width: 90,
      render: (v) => (
        <CardBodyDate>{fDateShort(v, DATE_FORMAT_DD_MMM_YYYY)}</CardBodyDate>
      ),
    },
    {
      id: 'state',
      label: 'Status',
      sortable: true,
      width: 80,
      render: (_, v) => (
        <StatusTag
          status={v.state}
          label={capitalize(v.state.toLowerCase())}
          colorMap={exportStatusColorMap}
          key={v.state}
        />
      ),
      align: 'center',
    },
  ],
  actions: [EnrichTableDownloadAction, EnrichTableAction],
  filters: [],
  actionsConfig: {
    label: 'Action',
    minWidth: '5%',
    align: 'center',
    sx: { display: 'flex', justifyContent: 'center', alignItems: 'center' },
  },
  hidePagination: true,
  stickyHeader: true,
  defaultOrderBy: 'modified',
  hideColumnsOnNoData: true,
  emptyProps: {
    emptyIcon: 'export',
    emptyIconWrapperSX: SX.emptyIconWrapper,
    titleSx: { fontSize: 14 },
    iconSize: 28,
  },

  hideResetFilters: true,
  cellSx: { p: 1 },
  bordered: 'solid',
};
